import styled from 'styled-components'

export const PoolAvatarsStyled = styled.div`
  display: flex;
  align-items: center;

  /* Ensure avatars stack properly */
  > * {
    position: relative;
  }

  /* Stack avatars by applying negative left margin to all but the first */
  > *:not(:first-child) {
    margin-left: ${(props) => props.theme.typography.pxToRem(-16)};
  }
`
